import React from 'react';
import style from './style.scss';
import {Input, Textarea} from 'components/vitrade-forms/common';
import BusinessContentContainer from './BusinessContentContainer.jsx';
import {Businesses} from 'api';
import {toastr} from 'react-redux-toastr';
import {CategorySelectorInput} from 'components/vitrade-forms';
import {SingleImageUploader} from 'components/uploader';
import {Link, withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import Recaptcha from 'react-recaptcha';

class Profile extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.props.validators['formEditBusiness'] = [];

    this.state = {
      business: this.props.business || {},
      agreeTOS: false
    }

  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.business != this.state.business) {
      this.setState({
        business: nextProps.business
      })
    }
  }

  submitForm(e) {
    //do something
    e.preventDefault();

    if (this.validateSubmitForm()) {
      let { agreeTOS, ...data } = this.state.business;
      // data['userId'] = this.props.auth.user.id;

      Businesses.actions.update.request({id: this.props.business.id}, {
        data: data
      }).then(response => {
        toastr.success('Thành công!', 'Thông tin doanh nghiệp đã được cập nhật thành công. Thông tin doanh nghiệp của bạn cần được kiểm duyệt trước khi được đưa lên sàn. Bạn vui lòng đợi trong giây lát.');
        //
        this.props.dispatch({
          type: 'UPDATE_BUSINESS_INFO',
          data: response.data
        })
        //this.props.history.push('/my-business/dashboard');

      }).catch(err => {
        console.log(err);
      });
    } else {
      toastr.error('Lỗi!', 'Có lỗi xảy ra. Bạn vui lòng kiểm tra lại thông tin');
    }


    return false;
  }

  validateSubmitForm() {
    let pass = true;
    this.props.validators['formEditBusiness'].map(validator => {
      if (pass)
        pass = validator.validate();
      else
        validator.validate();
    });

    if (!pass) {
      toastr.error('Lỗi!', 'Có lỗi xảy ra. Bạn vui lòng kiểm tra lại thông tin');
      return false;
    }

    return pass;
  }

  onChange(name, e) {
    this.setState({
      business: {
        ...this.state.business,
        [name]: e.target.value
      }
    })
  }

  onUploadComplete(image) {
    this.setState({
      business: {
        ...this.state.business,
        logo: image.name
      }

    })
  }

  removeImage() {
    this.setState({
      business: {
        ...this.state.business,
        logo: ''
      }
    });
  }

  selectCategories(value) {
    let categoryIds = [];
    value.map(item => {
      categoryIds.push(item.value);
    });

    this.setState({
      business: {
        ...this.state.business,
        categoryIds
      }
    });
  }

  onBusinessContentChange(newContents) {
    this.setState({
      business: {
        ...this.state.business,
        contents: newContents
      }
    });
  }

  render() {
    return (
      <section className="business-profile">
        <form onSubmit={this.submitForm.bind(this)}>
          <h2 className='business-profile-title'>Thông tin doanh nghiệp</h2>
          <div className='business-profile-wrap-content'>

            <div className='business-profile-content-left'>
              <SingleImageUploader fnUpload={Businesses.actions.upload.request}
                title="Logo công ty hoặc ảnh đại diện của doanh nghiệp"
                type="BUSINESS"
                image={this.state.business.logo}
                onRemoveImage={this.removeImage.bind(this)}
                onUploadComplete={this.onUploadComplete.bind(this)}
                confirmRemove={false}
              />
              <Input type="text" placeholder="Tên công ty..."
                className='has-feedback fg-custom'
                iconClassName='fa-user-o'
                value={this.state.business.name}
                required={true}
                onChange={this.onChange.bind(this, 'name')}
                bindValidator={this} channel="formEditBusiness"
                errorMessage="Tên doanh nghiệp không được để trống"
              />

              <Input type="text" placeholder="Địa chỉ..."
                className='has-feedback fg-custom'
                value={this.state.business.address}
                onChange={this.onChange.bind(this, 'address')}
                iconClassName='fa-map-marker'
                required={true}
                bindValidator={this} channel="formEditBusiness"
                errorMessage="Bạn vui lòng cung cấp email"
              />
              {
                /**
                <div className='business-profile-map form-group'>
                  <img className='business-profile-map-img' src={require('assets/images/company/map.png')}/>
                </div>
                **/
              }



              <CategorySelectorInput label="Chọn lĩnh vực kinh doanh" data={this.state.business.categoryIds}
                onChange={this.selectCategories.bind(this)}
              />

              <Textarea type="text" placeholder="Mô tả..."
                className='fg-custom vitrade-textarea'
                iconFontSet='glyphicon'
                iconClassName='glyphicon-user'
                value={this.state.business.description}
                onChange={this.onChange.bind(this, 'description')}
                required={true}
                bindValidator={this} channel="formEditBusiness"
                errorMessage="Bạn vui lòng nhập mô tả ngắn"
              />
            </div>

            <div className='business-profile-content-right'>
              <Input type="email" placeholder="Email của doanh nghiệp..."
                className='has-feedback fg-custom'
                iconClassName='fa-at'
                value={this.state.business.email}
                onChange={this.onChange.bind(this, 'email')}
                required={true}
                bindValidator={this} channel="formEditBusiness"
                errorMessage="Bạn vui lòng cung cấp email"
              />

              <Input type="text" placeholder="Mã số thuế..."
                className='has-feedback fg-custom'
                value={this.state.business.taxCode}
                onChange={this.onChange.bind(this, 'taxCode')}
                iconClassName='fa-briefcase'
                required={true}
                bindValidator={this} channel="formEditBusiness"
                errorMessage="Bạn vui lòng cung cấp mã số thuế"
              />


              <Input type="text" placeholder="Số điện thoại..."
                className='has-feedback fg-custom'
                iconFontSet='fa'
                iconClassName='fa-phone'
                value={this.state.business.phone}
                onChange={this.onChange.bind(this, 'phone')}
                required={true}
                bindValidator={this} channel="formEditBusiness"
                errorMessage="Bạn vui lòng cung cấp số điện thoại"
              />
              <button className='btn-update-profile'>Cập nhật thông tin</button>
            </div>
          </div>

          <BusinessContentContainer
            initialData={this.state.business.contents}
            onChange={this.onBusinessContentChange.bind(this)}
          />
        </form>
      </section>
    );
  }
}

Profile.defaultProps = {
  validators: {}
}

const bindStateToProps = state => {
  let business = {};
  if (state.myBusinesses && state.myBusinesses.mainBusiness) {
    business = state.myBusinesses.mainBusiness;
  }

  return {
    auth: state.auth,
    business: business
  }
}

export default withRouter(connect(bindStateToProps)(Profile));



// WEBPACK FOOTER //
// ./components/my-business/profile/Profile.jsx